module.exports = __webpack_public_path__ + "img/title6.b2707bd7.png";